export let DOCUMENTS = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.GOODS',
    value: 0,
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.DOCUMENTS',
    value: 1,
  },
];
export const DOCUMENTS_MAP = new Map<number, string>(
  DOCUMENTS.map((item) => [item.value, item.label]) as any
);

export function setDocuments(documents: typeof DOCUMENTS) {
  DOCUMENTS = documents;
}

export const DOCUMENTS_PARSE_MAP = new Map<
  string,
  { label: string; value: number }
>([
  [
    'document',
    {
      label: 'BATCH_MAILING.BATCHES_TAB.METADATA.DOCUMENTS',
      value: 1,
    },
  ],
  [
    'package',
    {
      label: 'BATCH_MAILING.BATCHES_TAB.METADATA.GOODS',
      value: 0,
    },
  ],
]);
